import services from '../../services';

const sequence = (a, b) => {
  if (a.displayIndex > b) {
    return 1;
  }
  if (a.displayIndex < b.displayIndex) {
    return -1;
  }
  return 0;
};

const filterDic = (commData, code) => {
  let dicList = [];
  commData.dataDictDetails && commData.dataDictDetails.forEach((itme, key) => {
    switch (itme.alignment) {
      case 0:
        itme.alignment = 'left';
        break;
      case 1:
        itme.alignment = 'right';
        break;
      case 2:
        itme.alignment = 'center';
        break;
    }
    switch (itme.titleAlignment) {
      case 0:
        itme.titleAlignment = 'left';
        break;
      case 1:
        itme.titleAlignment = 'right';
        break;
      case 2:
        itme.titleAlignment = 'center';
        break;
    }
    itme.code = code;
    if (itme.displayWidth > 0) {
      itme.displayWidth = itme.displayWidth * 1.2;
      itme.fieldColor = `#${String(itme.fieldColor).slice(-6)}`;
      dicList.push(itme);
    }
  });
  dicList.sort(sequence);
  return dicList;
};

const State = {
  dictionaryAction: [],
  controllerList: [], // 数据字典
  goodDicList: [],
  guestIDByConditionsList: [],
  bargainIDByConditionsList: [],
  refGoodsByConditionsList: [],
  carOrderBatch: [],
  carOrderBatchTransfer:[],
  carOrderBatchPipe:[],
  carOrderBatchOther:[],
  carOrderList: [],
  carOrderListTransfer:[],
  carOrderListPipe:[],
  carOrderListOther:[],
  TGuestIDByConditions: [],
  TankIDByConditions: [],
  TankIDByConditions1:[],
  adminMainOrder: [],
  adminCarOrderBatch: [],
  adminTGuestIDByConditions: [],
  TGuestIDByConditionsAction: [],
  adminCarOrderListAction: [],
  adminAccountBooksAction: [],
  GoodsAction: [],
  listInOutCarAction: [],
  enclosureAction: [],
  currInventory: [],
  currInventory2: [],
  CargoTransfer: [],
  CargoTransferDetail: [],
  BargainIDByConditions: [],
  listWebCusInGoods: [],
  listWebCusOutGoods:[],
  listWebCusfinancialset:[],
  listWebCusInOutDay:[],
  listwebCusGoods:[],
  shipDicList:[],
  shipSupplierList:[],
  goodsSupplierList:[],
  shipInOutAction: []
};

// getters
const Getters = {
  dictionaryAction: state => state.dictionaryAction,
  controllerList: state => state.controllerList,
  goodDicList: state => state.goodDicList,
  guestIDByConditionsList: state => state.guestIDByConditionsList,
  bargainIDByConditionsList: state => state.bargainIDByConditionsList,
  shipDicList:state=>state.shipDicList,
  shipSupplierList:state=>state.shipSupplierList,
  refGoodsByConditionsList: state => state.refGoodsByConditionsList,
  carOrderBatch: state => state.carOrderBatch,
  carOrderBatchTransfer: state => state.carOrderBatchTransfer,
  carOrderBatchPipe: state => state.carOrderBatchPipe,
  carOrderBatchOther: state => state.carOrderBatchOther,
  carOrderList: state => state.carOrderList,
  carOrderListTransfer: state => state.carOrderListTransfer,
  carOrderListPipe: state => state.carOrderListPipe,
  carOrderListOther: state => state.carOrderListOther,
  TGuestIDByConditions: state => state.TGuestIDByConditions,
  TankIDByConditions: state => state.TankIDByConditions,
  TankIDByConditions1: state => state.TankIDByConditions1,
  adminMainOrder: state => state.adminMainOrder,
  adminCarOrderBatch: state => state.adminCarOrderBatch,
  adminTGuestIDByConditions: state => state.adminTGuestIDByConditions,
  TGuestIDByConditionsAction: state => state.TGuestIDByConditionsAction,
  adminCarOrderListAction: state => state.adminCarOrderListAction,
  adminAccountBooksAction: state => state.adminAccountBooksAction,
  GoodsAction: state => state.GoodsAction,
  listInOutCarAction: state => state.listInOutCarAction,
  listWebCusInGoods: state => state.listWebCusInGoods,
  listWebCusOutGoods: state => state.listWebCusOutGoods,
  listWebCusfinancialset: state => state.listWebCusfinancialset,
  listWebCusInOutDay: state => state.listWebCusInOutDay,
  listwebCusGoods: state => state.listwebCusGoods,
  enclosureAction: state => state.enclosureAction,
  currInventory: state => state.currInventory,
  currInventory2: state => state.currInventory2,
  CargoTransfer: state => state.CargoTransfer,
  CargoTransferDetail: state => state.CargoTransferDetail,
  BargainIDByConditions: state => state.BargainIDByConditions,
  shipInOutAction: state => state.shipInOutAction,
};

// mutations
const Mutations = {
  setDictionaryAction(state, commData) {
    state.dictionaryAction = commData;
  },
  controllerList(state, commData) {
    state.controllerList = commData;
  },
  setGoodDicList(state, commData) {
    state.goodDicList = commData;
  },
  setGuestIDByConditionsList(state, commData) {
    state.guestIDByConditionsList = commData;
  },
  setBargainIDByConditionsList(state, commData) {
    state.bargainIDByConditionsList = commData;
  },
  setShipDicList(state, commData) {
    state.shipDicList = commData;
  },
  setShipSupplierList(state, commData) {
    state.shipSupplierList = commData;
  },
  setRefGoodsByConditionsList(state, commData) {
    state.refGoodsByConditionsList = commData;
  },

  setCarOrderBatch(state, commData) {
    state.carOrderBatch = commData;
  },
  setCarOrderBatchTransfer(state, commData) {
    state.carOrderBatchTransfer = commData;
  },
  setCarOrderBatchPipe(state, commData) {
    state.carOrderBatchPipe = commData;
  },
  setCarOrderBatchOther(state, commData) {
    state.carOrderBatchOther = commData;
  },

  setCarOrderList(state, commData) {
    state.carOrderList = commData;
  },
  setCarOrderListTransfer(state, commData) {
    state.carOrderListTransfer = commData;
  },
  setCarOrderListPipe(state, commData) {
    state.carOrderListPipe = commData;
  },
  setCarOrderListOther(state, commData) {
    state.carOrderListOther = commData;
  },

  setTGuestIDByConditions(state, commData) {
    state.TGuestIDByConditions = commData;
  },
  setTankIDByConditions(state, commData) {
    state.TankIDByConditions = commData;
  },
  setTankIDByConditions1(state, commData) {
    state.TankIDByConditions1 = commData;
  },
  setAdminMainOrder(state, commData) {
    state.adminMainOrder = commData;
  },
  setadminCarOrderBatch(state, commData) {
    state.adminCarOrderBatch = commData;
  },
  setTGuestIDByConditionsAction(state, commData) {
    state.TGuestIDByConditionsAction = commData;
  },
  setadminCarOrderListAction(state, commData) {
    state.adminCarOrderListAction = commData;
  },
  setadminAccountBooksAction(state, commData) {
    state.adminAccountBooksAction = commData;
  },
  setGoodsAction(state, commData) {
    state.GoodsAction = commData;
  },
  setlistInOutCarAction(state, commData) {
    state.listInOutCarAction = commData;
  },
  setlistWebCusInGoods(state, commData) {
    state.listWebCusInGoods = commData;
  },
  setlistWebCusOutGoods(state, commData) {
    state.listWebCusOutGoods = commData;
  },
  setlistwebCusGoods(state, commData) {
    state.listwebCusGoods = commData;
  },
  setlistWebCusInOutDay(state, commData) {
    state.listWebCusInOutDay = commData;
  },
  setlistWebCusfinancialset(state, commData) {
    state.listWebCusfinancialset = commData;
  },

  setEnclosureAction(state, commData) {
    state.enclosureAction = commData;
  },
  setShipInOutAction(state, commData) {
    state.shipInOutAction = commData;
  },
  setCurrInventory(state, commData) {
    state.currInventory = commData;
  },
  setCurrInventory2(state, commData) {
    state.currInventory2 = commData;
  },
  setCargoTransfer(state, commData) {
    state.CargoTransfer = commData;
  },
  setCargoTransferDetail(state, commData) {
    state.CargoTransferDetail = commData;
  },
  setBargainIDByConditions(state, commData) {
    state.BargainIDByConditions = commData;
  },
};
// actions
const Actions = {
  async getDictionaryAction({commit}, code) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setDictionaryAction', dicList);
    }
  },
  // 客服字典
  async controllerListAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 4926
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 4926);
      commit('controllerList', dicList);
    }
  },
  async getGoodDicList({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 3002
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 3002);
      commit('setGoodDicList', dicList);
      return dicList;
    }
  },
  async getGuestIDByConditionsList({commit},code=4000) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setGuestIDByConditionsList', dicList);
      return dicList;
    }
  },
  async getShipSupplierList({commit}){
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 2250
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 2250);
      commit('setShipSupplierList', dicList);
      return dicList;
    }
  },
  async getShipDicList({commit}){
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 3008
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 3008);
      commit('setShipDicList', dicList);
      return dicList;
    }
  },
  async getBargainIDByConditionsList({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 5150
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 5150);
      commit('setBargainIDByConditionsList', dicList);
      return dicList;
    }
  },
  async getRefGoodsByConditionsList({commit}, code=3002) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 4002);
      commit('setRefGoodsByConditionsList', dicList);
      return dicList;
    }
  },

  async getCarOrderBatch({ commit }, code) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderBatch', dicList);
      return dicList;
    }
    console.log(res.bean);
  },
  async getCarOrderBatchTransfer({ commit }, code) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderBatchTransfer', dicList);
      return dicList;
    }
  },
  async getCarOrderBatchPipe({ commit }, code) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderBatchPipe', dicList);
      return dicList;
    }
  },
  async getCarOrderBatchOther({ commit }, code) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderBatchOther', dicList);
      return dicList;
    }
  },

  async getCarOrderList({commit},code=9103) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderList', dicList);
      return dicList;
    }
  },
  async getCarOrderListTransfer({commit},code=9103) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderListTransfer', dicList);
      return dicList;
    }
  },
  async getCarOrderListPipe({commit},code=9103) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderListPipe', dicList);
      return dicList;
    }
  },
  async getCarOrderListOther({commit},code=9103) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setCarOrderListOther', dicList);
      return dicList;
    }
  },
  async getTGuestIDByConditions({commit}, code=5000) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setTGuestIDByConditions', dicList);
      return dicList;
    }
  },
  async getTankIDByConditions({commit}, code=2150) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setTankIDByConditions', dicList);
      return dicList;
    }
  },
  async getTankIDByConditions1({commit}, code=2150) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setTankIDByConditions1', dicList);
      return dicList;
    }
  },
  async getBargainIDByConditions({commit}, start) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 1500
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 1500);
      commit('setBargainIDByConditions', dicList);
      return dicList;
    }
  },



  // 客户字典
  async adminMainOrderAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 2926,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 2926);
      commit('setAdminMainOrder', dicList);
      return dicList;
    }
  },
  async currInventoryAction({commit}, dicID) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: dicID,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 2926);
      commit('setCurrInventory', dicList);
      return dicList;
    }
  },
  async currInventory2Action({commit}, dicID) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: dicID,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 2926);
      commit('setCurrInventory2', dicList);
      return dicList;
    }
  },
  async CargoTransferAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 3161,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 3161);
      commit('setCargoTransfer', dicList);
      return dicList;
    }
  },
  async CargoTransferDetailAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 3162,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 2162);
      commit('setCargoTransferDetail', dicList);
      return dicList;
    }
  },
  async getTGuestIDByConditionsAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: 7000,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 3000);
      commit('setTGuestIDByConditionsAction', dicList);
      return dicList;
    }
  },
  async adminCarOrderBatchAction({commit}, start) {
    let code = 2927;
    if (start) {
      code = 3927
    }
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setadminCarOrderBatch', dicList);
      return dicList;
    }
  },
  async adminCarOrderListAction({commit}) {
    let code = 2928;
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      params: code,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, code);
      commit('setadminCarOrderListAction', dicList);
      return dicList;
    }
  },
  // 库存帐页
  async getAdminAccountBooksAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 3547,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 3547);
      commit('setadminAccountBooksAction', dicList);
      return dicList;
    }
  },
  async getGoodsAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 4002,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 4002);
      commit('setGoodsAction', dicList);
      return dicList;
    }
  },
  async getlistInOutCarAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 4535,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 4535);
      commit('setlistInOutCarAction', dicList);
      return dicList;
    }
  },
  async getlistWebCusInGoods({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 4520,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 4520);
      commit('setlistWebCusInGoods', dicList);
      return dicList;
    }
  },
  async getlistWebCusOutGoods({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 5520,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 5520);
      commit('setlistWebCusOutGoods', dicList);
      return dicList;

    }
  },
  async getlistwebCusGoods({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 3520,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 3520);
      commit('setlistwebCusGoods', dicList);
      return dicList;
    }
  },
  async getlistWebCusInOutDay({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 6520,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 6520);
      commit('setlistWebCusInOutDay', dicList);
      return dicList;

    }
  },
  async getlistWebCusfinancialset({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 2520,
    });
    if (res.status) {
      const dicList = filterDic(res.bean, 2520);
      commit('setlistWebCusfinancialset', dicList);
      return dicList;

    }
  },
  async getEnclosureAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 865,
    });
    if (res.status) {
      const dicList = filterDic(res.bean);
      commit('setEnclosureAction', dicList);
      return dicList;
    }
  },
   async getShipInOutAction({commit}) {
    let res = await services.postParams({
      type: 'DICTIONSAY',
      url: 'getDataDictId',
      cache: true,
      params: 11206,
    });
    if (res.status) {
      const dicList = filterDic(res.bean);
      commit('setShipInOutAction', dicList);
      return dicList;
    }
  },
};

export default {
  namespaced: true,
  strict: true,
  state: State,
  getters: Getters,
  actions: Actions,
  mutations: Mutations
};
